let root = {};

export function getText(_root = {}, key = '', defaultText = '') {
  return _root[key] || defaultText;
}

export function get(key) {
  return root[key];
}

export function setRoot(i18nObj) {
  root = i18nObj;
}

export function getAll(i18nPrefix) {
  const group = {};
  Object.keys(root).forEach(keyName => {
    if (keyName.indexOf(i18nPrefix) === 0) {
      // 引入传入的"namespace"，实际需要截取的位置是"namespace."
      const subName = keyName.slice(i18nPrefix.length + 1);
      group[subName] = root[keyName];
    }
  });

  return group;
}
